import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const resumeAPI = createApi({
  reducerPath: "resumeAPI",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
    prepareHeaders: (headers) => {
      // const token = Cookies.get('authToken');
      const token =
        '_ga=GA1.1.2087826858.1709879017; _hjSessionUser_3527615=eyJpZCI6IjhkMWE0Nzg1LTdhNTYtNTQwYy05MWE2LTljMTFkMTkyNTI3NSIsImNyZWF0ZWQiOjE3MDk4NzkwMjMwOTUsImV4aXN0aW5nIjp0cnVlfQ==; _hjSession_3527615=eyJpZCI6Ijg3NWUwYmNlLWYyOTItNGZiZC05YTcxLWM5Y2NkMDlhYTU0NSIsImMiOjE3MDk4NzkwMjMwOTYsInMiOjEsInIiOjEsInNiIjowLCJzciI6MCwic2UiOjAsImZzIjoxLCJzcCI6MX0=; _secure_ref=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6ImFrQGdtYWlsLmNvbSIsImlhdCI6MTcwOTg3OTA5NCwiZXhwIjoxNzE1MDYzMDk0fQ.pEXIZvgMSafjc3doB09LvvHrkzKtOCa9z9uhlOXGQLw; cookiesAccepted=true; _secure_ARJ_=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6ImFrQGdtYWlsLmNvbSIsImlhdCI6MTcwOTg3OTA5MCwiZXhwIjoxNzA5ODgyNjkwfQ.PuNfX6J9oqKDlUqCLylABcEF-Eq1ecJ4LmWQixuUTZk; _ga_WWGF86YTQ4=GS1.1.1709879017.1.1.1709879120.0.0.0; _hjShownFeedbackMessage=true';
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    apiresume: builder.mutation({
      query: (payload) => ({
        url: `/user-resume-upload`,
        method: "POST",
        body: payload,
      }),
    }),
  }),
});

export const { useApiresumeMutation } = resumeAPI;